export default __webpack_public_path__ + "2e5b464ef69e5ae179ca94740dcb8325.png";